import { createAction, props } from '@ngrx/store';
import { ErrorInterface } from '../../interfaces/general.interface';
import { LoginInterface } from '../../interfaces/auth.interface';

enum LoginCredentialsActionType {
  loginCredentials = '[login credentials] login credentials',
  requestSuccess = '[login credentials] success login credentials',
  requestError = '[login credentials] error login credentials',
  clearLoginCredentials = '[login credentials] clear login credentials',
}

export const loginCredentials = createAction(
  LoginCredentialsActionType.loginCredentials,
  props<{ params: LoginInterface }>()
);

export const requestSuccess = createAction(
  LoginCredentialsActionType.requestSuccess,
  props<{ response: any }>()
);

export const requestError = createAction(
  LoginCredentialsActionType.requestError,
  props<{ error: ErrorInterface }>()
);

export const clearLoginCredentials = createAction(
  LoginCredentialsActionType.clearLoginCredentials
);
